/* eslint-disable import/no-unassigned-import */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/naming-convention */

import { type App } from '~/app';

import JsController from '../../js-controller';

import './salesforce-chat.scss';

export default (app: App) => {

    const controller = new JsController(app, 'salesforce-chat');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

declare let embedded_svc:any;
declare const window: any;

export function mountComponent( controller: JsController ) {
    const salesforceElement= document.querySelector<HTMLElement>("#salesforce-chat");
    if(salesforceElement){
        const salesforceOrgId= salesforceElement.dataset.salesforceOrgId;
        const securedDomain= salesforceElement.dataset.securedDomain;
        const publicDomain= salesforceElement.dataset.publicDomain;
        const scriptLocation= salesforceElement.dataset.scriptLocation??"";
        const apiEndpoint= salesforceElement.dataset.apiEndpoint;
        const apiContentEndpoint= salesforceElement.dataset.apiContentEndpoint;
        const chatButtonId= salesforceElement.dataset.chatButtonId;
        const deploymentId= salesforceElement.dataset.deploymentId;
        const eswDevelopmentName= salesforceElement.dataset.eswDevName;
        const developerName= salesforceElement.dataset.developerName;
        const chatAvatar= salesforceElement.dataset.chatAvatar;
        const defaultMinimizedText= salesforceElement.dataset.defaultMinimizedText;
        const disabledDefaultMinimizedText= salesforceElement.dataset.disableMinimizedText;
        const eswUrl= salesforceElement.dataset.eswUrl??"https://service.force.com";

        const initESW = function(gslbBaseURL:string|null) {
            embedded_svc.settings.displayHelpButton = true; //Or false
            embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'

            embedded_svc.settings.defaultMinimizedText = defaultMinimizedText; //(Defaults to Chat with an Expert)
            if(chatAvatar)
            {
                embedded_svc.settings.chatbotAvatarImgURL = chatAvatar;
            }
            
            if(disabledDefaultMinimizedText)
            {
                embedded_svc.settings.disabledMinimizedText = disabledDefaultMinimizedText; 
            }

            embedded_svc.settings.extraPrechatFormDetails = [{
                "label": "URL",
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                "value": window.location.href,
                "displayToAgent": true,
                "transcriptFields": ["URL__c"]
            }];
        
            embedded_svc.settings.enabledFeatures = ['LiveAgent'];
            embedded_svc.settings.entryFeature = 'LiveAgent';

            embedded_svc.init(
                securedDomain,
                publicDomain,
                gslbBaseURL,
                salesforceOrgId,
                developerName,
                {
                    "baseLiveAgentContentURL": apiContentEndpoint,
                    "deploymentId": deploymentId,
                    "buttonId": chatButtonId,
                    "baseLiveAgentURL": apiEndpoint,
                    "eswLiveAgentDevName":eswDevelopmentName,
                    "isOfflineSupportEnabled": false
                }
            );
        };

        if (window.embedded_svc) {
            initESW(eswUrl);
        } else {
            const s = document.createElement('script');
            s.setAttribute('src', scriptLocation);
            s.addEventListener('load', function() {
                initESW(null);
            });

            document.body.append(s);
        }
        
        //transforming sitecore js to proper ts here
        (function () {

            const closeInviteElement = document.querySelector<HTMLElement>('#closeInvite');
            const rejectInviteElement = document.querySelector<HTMLElement>('#rejectInvite');
            const acceptInviteElement = document.querySelector<HTMLElement>('#acceptInvite');

            if(closeInviteElement)
                controller.addListener(closeInviteElement, "click", () => embedded_svc.inviteAPI.inviteButton.rejectInvite())
            if(rejectInviteElement)
                controller.addListener(rejectInviteElement, "click", () => embedded_svc.inviteAPI.inviteButton.rejectInvite())
            if(acceptInviteElement)
                controller.addListener(acceptInviteElement, "click", () => embedded_svc.inviteAPI.inviteButton.acceptInvite())

            const targetNode = document.querySelector<HTMLElement>("#snapins_invite");
            if(targetNode){
                const config = { attributes: true, childList: false, subtree: false };

                const callback = () => {
                    const snapinsInvite = document.querySelector<HTMLElement>('#snapins_invite');
                    if(snapinsInvite)
                        snapinsInvite.style.position='fixed';

                    const serviceIcon = document.querySelector<HTMLElement>('.embeddedServiceIcon');
                    if(serviceIcon)
                        serviceIcon.dataset.icon= "💬";
                };

                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
        })();
    }
}
